import { ViewFactory } from 'wdc-cube-react'

import { MultiSelectionScope } from '../MultiSelection.scopes'
import { MultiSelectionView } from './MultiSelection.view'

export function registerViews(rv = ViewFactory.register) {
    rv(MultiSelectionScope, MultiSelectionView)
}